import AppHeader from '../app/appHeader';
import React, { FC } from 'react';
import './styles/registration.scss';
import { InfoInactiveIcon } from '@getgo/chameleon-icons/react';
import { Alert, Typography } from '@getgo/chameleon-web/react';
import Footer from '../footer/footer';
import { useTranslation } from 'react-i18next';

const EventNotAvailable: FC = () => {
  const { t } = useTranslation();
  return (
    <div className="cancel-registration-grid">
      <AppHeader />
      <div className="cancel-registration">
        <div className="box">
          <div className="box-space">
            <div>
              <Typography color="text-01" variant="heading-large">
                {t('eventNotAvailable.title')}
              </Typography>
            </div>
            <div className="cancel-registration-description">
              <Typography color="text-01" variant="body-large">
                {t('eventNotAvailable.description')}
              </Typography>
            </div>
          </div>
          <Alert icon={<InfoInactiveIcon />}>
            <Typography color="text-01">{t('eventNotAvailable.alertText')}</Typography>
          </Alert>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default EventNotAvailable;
